<script>

export default {
  name: 'contacts-menu',
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    },
    offices() {
      return this.$store.getters['contacts/collection']
    }
  },
  created() {
    this.$store.commit('contacts/setIsCollectionLoading', true)

    this.$store.dispatch('contacts/getCollection')
  }
}
</script>

<template>
  <b-dropdown
    :hoverable="true"
    aria-role="list"
    class="app-header__dropdown"
    position="is-bottom-left"
  >
    <button
      slot="trigger"
      class="app-header__dropdown-button button"
    >
      <span>Контакты</span>
      <b-icon icon="menu-down" />
    </button>
    <div
      v-for="(category, index) in offices"
      :key="index"
      class="app-header__dropdown-category"
    >
      <b-dropdown-item
        v-if="category.title"
        class="app-header__dropdown-item app-header__dropdown-item--header"
      >
        {{ category.title }}
      </b-dropdown-item>
      <b-dropdown-item
        v-for="office in category.offices"
        :key="`${index}_${office.slug}`"
        :has-link="true"
        aria-role="listitem"
        class="app-header__dropdown-item"
      >
        <router-link
          :to="{
            name: 'Contacts',
            params: {
              slug: office.slug
            }
          }"
        >
          {{ office.name }}
        </router-link>
      </b-dropdown-item>
      <hr>
    </div>
  </b-dropdown>
</template>
